import { useEffect } from "react";
import apiData from "lib/stores/apiData";
import mapData from "lib/stores/mapData";
import { useSnapshot } from "valtio";
import styles from "./index.module.scss";
import classNames from "classnames";
import context from "lib/stores/context";
import DataPanelWrapper from "./DataPanelWrapper";
import api from "lib/api";

export default function InFocusPanel() {
  const { globals, metadata, worldwide, countries, regions } = useSnapshot(apiData, { sync: true });
  const { year } = useSnapshot(mapData, { sync: true });
  const { activeTabWorldwide, activeTabCountries, activeTabRegions, activeView, activeCountry, activeRegion } = useSnapshot(context, {
    sync: true
  });

  const isMounted = () => {
    if (
      (activeTabWorldwide === 2 && activeView === "worldwide") ||
      (activeTabRegions === 1 && activeView === "region") ||
      (activeTabCountries === 1 && activeView === "country")
    ) {
      return true;
    }
    return false;
  };

  const renderFocusItems = () => {
    if (activeView === "country") {
      try {
        return countries[activeCountry]?.documents?.map((article: any, i) => {
          try {
            return <ArticleItem key={i} article={article} />;
          } catch (error) {
            return null;
          }
        });
      } catch (error) {
        return [];
      }
    }
    if (activeView === "region") {
      try {
        return metadata.regions
          .find(region => {
            return region.id === activeRegion;
          })
          .documents.map((article: any, i) => {
            try {
              return <ArticleItem key={i} article={article} />;
            } catch (error) {
              return null;
            }
          });
      } catch (error) {
        return [];
      }
    }
    try {
      return worldwide.documents.map((article: any, i) => {
        try {
          return <ArticleItem key={i} article={article} />;
        } catch (error) {
          return null;
        }
      });
    } catch (error) {
      return [];
    }
  };

  return (
    <DataPanelWrapper className="pt-5" isMounted={isMounted}>
      {renderFocusItems()}
    </DataPanelWrapper>
  );
}

const ArticleItem = ({ article }) => {
  return (
    <div className="mb-6 w-full flex flex-col items-start justify-start md:px-0 px-[1.35rem]">
      <p className={classNames(styles["article-type"], "font-[700] text-[12px] rubik uppercase text-[#727288] uppercase")}>
        {article.type}
      </p>
      <p className={classNames(styles["article-title"], "text-[20px] pb-[4px] source text-black")}>{article.title}</p>
      <p className={classNames(styles["article-copy"], "text-[14px] source text-[#333353]")}>{article.copy}</p>
      <a
        className="text-[14px] font-[600] underline hover:underline hover:font-[600] hover:text-black source text-[#333353] pt-[2px] pb-1"
        href={article.link}
      >
        Read More
      </a>
    </div>
  );
};
